import { Component } from "react"

/* Constants */
import { utils } from "../constants"
import { CHOICE, DEALING } from "../constants/status"


/*
    Result — overlay shown once the round is settled.
    Props:
        result   { text, sum, positions, sideResults }
        status   current game status
        currency player currency code
*/
class Result extends Component {

    render = () => {

        const { result, status, currency } = this.props

        if (!result || status === CHOICE || status === DEALING) {
            return null
        }

        const win = parseFloat(result.sum) > 0

        /* Surrender — half the stake is returned, so it reads as neither a
           win nor a straight loss; show the returned amount instead. */
        if (result.surrender) {
            return (
                <div className="bj-result-container">
                    <div className="bj-result bj-result-surrender">
                        <div className="bj-result-title">ВЫ СДАЛИСЬ</div>
                        {win &&
                            <div className="bj-result-sum">{utils.convertor(result.sum, currency)}</div>
                        }
                    </div>
                </div>
            )
        }

        return (
            <div className="bj-result-container">

                <div className={`bj-result bj-result-${result.text || "lose"}`}>
                    <div className="bj-result-title">
                        {win ? "ВЫ ВЫИГРАЛИ" : "ДИЛЕР ВЫИГРАЛ"}
                    </div>
                    {win &&
                        <div className="bj-result-sum">{utils.convertor(result.sum, currency)}</div>
                    }
                </div>

            </div>
        )
    }
}

export default Result
